module.exports = __webpack_public_path__ + "static/media/performance.df6c3794.svg";